export * from './src/restaurants-menus-v1-menu-menus.schemas.js';
